import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { connect } from 'react-redux';
import Summary from '../../components/summary/index';
import Table from '../../components/table/profitlossreport';
import Portifolio from '../portfolio-x-ray/portfolio-x-ray'
import CapitalGain from '../capitalgain/capitalgain'
import AccountStatement from '../accountstatement/accountstatement'
import PortfolioReport from '../portfolioreport/portfolioreport'
import combineStyle from "../../utils/stylesheets/combainstyle/combainstyle";
import commonstyletable from "../../utils/stylesheets/table/commontablestyle";
import { replaceNull, sortArray } from '../../utils/commonfunction';
import Transaction from '../transaction/transactionreport'
import XrayWithRedemption from '../x-raywithredemption/x-raywithredemption'
import MaturityTracker from '../maturity_tracker/maturitytracker';
import '../../utils/stylesheets/tabs/tabs.css'
import secureStorage from '../../utils/securestorage';
import labels from '../../utils/constants/labels';
import Label from '../../utils/constants/labels';
import constants from '../../utils/constants/apiconstant';
import {
  bondsFilterChange,
} from "../../redux/actions/portfolioxray/portfolioxray";
import { bindActionCreators } from "redux";
import { bonds_transactionfilter, } from '../../redux/actions/transaction/actions';
import { bondsprofitandlossfilter, getProfitLossDetails } from '../../redux/actions/profitloss/profitlossaction'
import { filterMaturityTrackerBonds } from '../../redux/actions/maturitytracker/maturitytrackeraction'
import getAllTransferIn from '../../api/transferin/transferin';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        // <Typography>{children}</Typography>      
        <div
          style={{
            fontSize: '1rem',
            fontWeight: 400,
            lineHeight: 1.5,
            letterSpacing: '0.00938rem',
          }}
        >{children}</div>

      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}
const Styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    // backgroundColor: theme.palette.background.paper,
  },
  tabRoot: {
    "& .MuiTab-root:focus": {
      color: window.globalConfig.color.BROWN
    },
    "& .MuiTab-textColorPrimary.Mui-selected": {
      color: window.globalConfig.color.BROWN
    }
  },
  transactionContainer: {
    display: "grid",
    gridTemplateColumns: "10% 37% 12% 10% 13% 18%",
    marginLeft: "20px",
    alignContent: "center",
    [theme.breakpoints.down("920")]: {
      gridTemplateColumns: "repeat(2,1fr)",
      gridTemplateAreas: `"${"dategrid"} ${"dategrid"}"
      "${"schemegrid"} ${"schemegrid"}"
      "${"assetClassgrid"} ${"transactionTypegrid"}"
      "${"folioNumbergrid"} ${"unitgrid"}"
      "${"navgrid"} ${"amountgrid"}"`,
      padding: 10,
      gap: 10
    }
  },
  portfolioXraySevenSplitContainer: {
    display: "grid",
    gridTemplateColumns: "25% 15% 15% 15% 15% 15%",
    marginLeft: 20,
    [theme.breakpoints.down("920")]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr) !important',
      gap: 1,
      gridTemplateRows: 'auto',
      paddingRight: 10,
      gridTemplateAreas: `"schemeFirstGrid  . schemeFifthGrid"
  "schemeSecondGrid . schemeSixthGrid"
  "schemeThirdGrid . investedAmountGrid"`,
      "& .schemeFourthGrid": {
        display: "none"
      }
    },
  },
  accountStatementContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(6,1fr)",
    // marginLeft: "20px",
    alignContent: "center",
    paddingLeft: 10,
    paddingRight: 10,
    "& .thirdGrid": {
      textAlign: "right"
    },
    "& .fourthGrid": {
      textAlign: "right"
    },
    "& .fifthGrid": {
      textAlign: "right"
    },
    "& .sixthGrid": {
      textAlign: "right"
    },
    [theme.breakpoints.down("920")]: {
      gridTemplateColumns: "repeat(3,1fr)",
      gridTemplateAreas: `"${"firstGrid"} ${"secondGrid"} ${"thirdGrid"} "
      "${"fourthGrid"} ${"fifthGrid"} ${"sixthGrid"}"
      `,
      "& .firstGrid": {
        alignItems: "start !important"
      },
      "& .secondGrid": {
        alignItems: "center !important",
        textAlign: "center"
      },
      "& .thirdGrid": {
        alignItems: "end !important",
        textAlign: "end"
      },
      "& .fourthGrid": {
        alignItems: "start !important"
      },
      "& .fifthGrid": {
        alignItems: "center !important",
        textAlign: "center"
      },
      "& .sixthGrid": {
        alignItems: "end !important",
        textAlign: "end"
      },
      padding: 10,
      gap: 10
    }
  },
  xrayWithRedemptionFirstContainer: {
    display: "grid",
    gridTemplateColumns: "17% 7% 10% 10% 7% 10% 10% 7% 11% 11% !important",
    // paddingLeft:"10px"
    //marginLeft: "20px",

    paddingLeft: 10,
    paddingRight: 10,
    "& .firstGrid": {
      alignItems: "flex-start",
      textAlign: "left"
    },
    [theme.breakpoints.down("920")]: {
      gridTemplateColumns: "repeat(2,1fr) !important",
      padding: 5,
      gap: 10,
      // marginRight: 9,
      gridTemplateAreas: `"firstGrid firstGrid"
      "ninthGrid tenthGrid"
     `,
      "& .firstGrid": {
        alignItems: "flex-start",
        textAlign: "left"
      },
      "& .secondGrid": {
        display: "none"
      },
      "& .thirdGrid": {
        display: "none"
      },
      "& .fourthGrid": {
        display: "none"
      },
      "& .fifthGrid": {
        display: "none"
      },
      "& .sixthGrid": {
        display: "none"
      },
      "& .seventhGrid": {
        display: "none"
      },
      "& .eighthGrid": {
        display: "none"
      },
      "& .ninthGrid": {
        alignItems: "flex-start",
        textAlign: "left !important"
      }
    }
  },
  xrayWithRedemptionSecondContainer: {
    display: "grid",
    gridTemplateColumns: "16% 7% 10% 10% 7% 10% 10% 7% 10% 10%",
    gap: 3,
    paddingRight: 10,
    "& .eleventhGrid": {
      textAlign: "left",
      alignItems: "flex-start"
    },
    [theme.breakpoints.down("920")]: {
      gap: 6,
      gridTemplateColumns: "repeat(3,1fr)",
      gridTemplateAreas: `"eleventhGrid eleventhGrid eleventhGrid"
      "twelfthGrid thirteenthGrid fourteenthGrid"
      "fifteenthGrid sixteenthGrid seventeenthGrid"
      "eighteenthGrid ninteenthGrid twentiethGrid"`,
      "& .eleventhGrid": {
        textAlign: "left",
        alignItems: "flex-start"
      },
      "& .thirteenthGrid": {
        textAlign: "center"
      },
      "& .fourteenthGrid": {
        textAlign: "right"
      },
      "& .seventeenthGrid": {
        textAlign: "right"
      },
      "& .sixteenthGrid": {
        textAlign: "center"
      },
      "& .ninteenthGrid": {
        textAlign: "center"
      },
      "& .twelfthGrid": {
        textAlign: "left"
      },
      "& .fifteenthGrid": {
        textAlign: "left"
      },
      "& .eighteenthGrid": {
        textAlign: "left"

      }

    }
  },
  portfolioReportEightSplitContainer: {
    display: "grid",
    gridTemplateColumns: "30% 10% 10% 10% 10% 10% 10% 10%",
    // marginLeft: "20px",
    padding: 8,

    alignContent: "center",
    "& .firstGrid": {
      alignItems: "flex-start",
      textAlign: "left"
    },
    [theme.breakpoints.down("920")]: {
      gridTemplateColumns: "repeat(3,1fr)",
      gridTemplateAreas: `"${"firstGrid"} ${"firstGrid"} ${"eighthGrid"}"
      "${"secondGrid"} ${"thirdGrid"} ${"fourthGrid"} "
      " ${"fifthGrid"} . ${"sixthGrid"}"`,
      gap: 10,
      "& .firstGrid": {
        alignItems: "flex-start",
        textAlign: "left"
      },
      "& .secondGrid": {
        textAlign: "left"
      },
      "& .thirdGrid": {
        // alignItems: "flex-start",
        textAlign: "center"
      },
      "& .fourthGrid": {
        alignItems: "center"
      },
      "& .fifthGrid": {
        textAlign: "left"
      },
      "& .sixthGrid": {
        alignItems: "flex-start",
        textAlign: "right"
      },
      "& .seventhGrid": {
        alignItems: "center",
        display: "none"
      },
      "& .eighthGrid": {
        alignItems: "flex-end"
      }
    }
    // columnGap:'1%',
    // paddingLeft: "10px"
  },
  portfolioReportTenSplitContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(10,1fr)",
    alignContent: "center",
    "& .ninthGrid": {
      textAlign: "left"
    },
    paddingRight: 10,
    [theme.breakpoints.down("920")]: {
      gridTemplateColumns: "repeat(3,1fr) !important",
      gridTemplateAreas: `"${"ninthGrid"} ${"twelfthGrid"} eighteenthGrid"
      "${"tenthGrid"} ${"thirteenthGrid"} ${"fifteenthGrid"} "
      " ${"eleventhGrid"} ${"seventeenthGrid"} ${"sixteenthGrid"}"
      `,
      padding: 10,
      gap: 10,
      "& .ninthGrid": {
        textAlign: "left"
      },
      "& .tenthGrid": {
        textAlign: "left"
      },
      "& .fourteenth": {
        display: "none",
      },
      "& .fifteenthGrid": {
        //  display: "none",
        textAlign: "right"
      },
      "& .seventeenthGrid": {
        textAlign: "center",
      },
      "& .sixteenthGrid": {
        // display: "none",
        textAlign: "right",
        alignItems: "center"
      },
      "& .eleventhGrid": {
        textAlign: "left",
      },
      "& .thirteenthGrid": {
        textAlign: "center"
      },
      "& .twelfthGrid": {
        textAlign: "center"
      },
      "& .eighteenthGrid": {
        textAlign: "right"
      }
    }

  },
  taxationFourSplitContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(4,1fr)",
    paddingLeft: "10px",

    [theme.breakpoints.down("920")]: {
      gridTemplateColumns: "repeat(2,1fr)",
      gridTemplateAreas: `"firstGrid firstGrid"
      "secondGrid thirdGrid"
      "fourthGrid ."`,
      gap: 5,
      marginTop: 10,
      padding: 10,
      "& .firstGrid": {
        textAlign: "center !important"
      },
      "& .secondGrid": {
        alignItems: "flex-start",
        textAlignLast: "left"
      },
      "& .thirdGrid": {
        alignItems: "end",
        textAlignLast: "right"
      },
      "& .fourthGrid": {
        alignItems: "flex-start",
        textAlignLast: "left"
      }
    }
  },
  portfolioXrayCatrgorySevenSplitContainer: {
    display: "grid",
    gridTemplateColumns: "25% 15% 15% 15% 15% 15% !important",
    // paddingLeft: "10px"
    marginLeft: "20px",
    alignContent: "center",
    [theme.breakpoints.down("920")]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr) !important',
      gridTemplateAreas: `"categorySchemeGrid categoryInvestedGrid"
      ". categoryNetpl"
     `,
    }
  },
  FourSplitContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(4,1fr)",
    paddingLeft: "10px",
    [theme.breakpoints.down("920")]: {
      gridTemplateColumns: "repeat(3,1fr)",
    }
  },
  bondsTransferinPortfolioXray: {
    display: "grid",
    gridTemplateColumns: "33% 33% 33% !important",
    "& .investedAmountGrid": {
      display: "none"
    },
    "& .myLastGrid": {
      display: "none"
    },
    "& .schemeFifthGrid": {
      display: "none"
    },
    "& .schemeSixthGrid": {
      display: "none"
    },
    [theme.breakpoints.down("920")]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr) !important',
      gap: 10,
      gridTemplateRows: 'auto',
      paddingRight: 10,
      gridTemplateAreas: `"schemeFirstGrid ."
  "schemeFourthGrid  schemeThirdGrid"
  `,
      "& .schemeFourthGrid": {
        alignItems: "flex-start"
      },
      "& .schemeThirdGrid": {
        alignItems: "flex-end"
      }
    },
  },
  bondsTransferinPortfolioXrayCategory: {
    display: "grid",
    gridTemplateColumns: "33% 33% 33% !important",
    // paddingLeft: "10px"
    //marginLeft: "20px",
    alignContent: "center",

    "& .categoryAbsoluteGainLossGrid": {
      display: "none"
    },

    [theme.breakpoints.down("920")]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr) !important',
      gridTemplateAreas: `"categorySchemeGrid ."
      "categoryInvestedGrid"
     `,
      "& .categoryNetpl": {
        display: "none"
      }
    }
  },
  profitLossContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(6,1fr)",
    marginLeft: "7px",
    [theme.breakpoints.down("920")]: {
      gridTemplateColumns: "repeat(2,1fr)",
      gridTemplateAreas: `"${"firstGrid"} ${"sixthGrid"}"
                         "${"thirdGrid"} ${"fourthGrid"}"
                         "${"secondGrid"} ${"fifthGrid"}"`,
    }
  }

});
const portfoliotitle = [{ "name": labels.PortfolioReport.type }, { "name": labels.PortfolioReport.date }, { "name": labels.PortfolioReport.quantity, "subheader": labels.PortfolioReport.PRICE },
{ "name": labels.PortfolioReport.gross, "subheader": labels.PortfolioReport.PRICE }, { "name": labels.PortfolioReport.currentamt }, { "name": labels.PortfolioReport.profitloss }, { "name": labels.PortfolioReport.int },
{ "name": labels.PortfolioReport.netG, "subheader": labels.PortfolioReport.loss }, { "name": labels.PortfolioReport.day }, { "name": labels.PortfolioReport.absret, "subheader": labels.PortfolioReport.xirr }]
const portfolioxraytitle = [{ "name": labels.Tableheader.BondName }, { "name": labels.Tableheader.quantity, "subheader": labels.Tableheader.Avgprice }, { "name": labels.Tableheader.InvestedValue, "subheader": labels.Tableheader.amount }, { "name": labels.Tableheader.CurrentValue, "subheader": labels.Tableheader.Subheadingcurrent }, { "name": labels.Tableheader.unrealised, "subheader": "Interest" }, { "name": labels.Tableheader.Net, "subheader": labels.Tableheader.SubheadingNet }]
const xraywithredeemptiontitle = [{ "name": labels.Tableheader.BondName }, { "name": labels.xraywithredemption.quantity }, { "name": "invested", 'subheader': "Amount" }, { "name": "current", "subheader": "Value", 'subheader1': "gainloss" },
  , { "name": labels.xraywithredemption.quantity }, { "name": "invested", 'subheader': "Amount" }, { "name": "Sold", "subheader": "Value", 'subheader1': "gainloss" },
  , { "name": labels.xraywithredemption.quantity }, { "name": "invested", 'subheader': "Amount" }, { "name": "Value", 'subheader1': "gainloss" }]
const accountstatementtitle = [{ "name": labels.Accountstatement.Date }, { "name": labels.Accountstatement.Txntype, "subheader": labels.Accountstatement.Txnnature }, { "name": labels.Accountstatement.Amount, align: "right" }, { "name": labels.Accountstatement.quantity, align: "right" }, { "name": labels.Accountstatement.Price, align: "right" }, { "name": labels.Accountstatement.Balquantity, align: "right" }]
const transferIntitle = [{ "name": labels.Tableheader.ScripName }, { "name": labels.Tableheader.quantity, }, { "name": labels.Tableheader.CurrentValue, },]
class BondsTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      transferInLoader: false,
      transferIn: [],
      YearCode: "All"
    }
  }

  componentDidMount() {
    document.title = window.globalConfig.companyDetails.companyName + " - Bonds/NCD"
    const { page, xray } = this.props;
    // 
    // console.log(page)
    //if (prev.page != page) {
    if (page.state != undefined) {
      // if (prev.page.state.tabValue != page.state.tabValue) {
      this.setState({ value: page.state.tabValue })
      // }
    }
    //}
    this.transferInReport()
  }

  componentDidUpdate(prev) {
    const { page, logindetails, clientID, date, L5ID } = this.props;
    // 

    // if (prev.page != page) {
    if (prev.page.state != undefined) {
      if (prev.page.state.tabValue != page.state.tabValue) {
        this.setState({ value: page.state.tabValue })
      }
    }
    // }
    //
    if (prev.clientID != clientID || prev.date != date || prev.L5ID != L5ID) {
      this.transferInReport()
    }
  }
  transferInReport = () => {
    if (this.state.transferInLoader == false) {
      this.setState({ transferInLoader: true })
      getAllTransferIn(this.props.logindetails.ClientID, this.props.date, this.props.logindetails.SessionID, 3, this.props.L5ID, 0).then((res) => {
        this.setState({ transferInLoader: false })
        if (res.status == "S" && res.data != null && res.data.length != 0) {
          this.setState({
            transferIn: res.data.map((item) => {
              return { Scheme: item.ScripName, TotalMarketValue: item.TotalCurrentMarketValuation, CurrentMarketValuation: item.CurrentMarketValuation, Units: item.Units }
            })
          })
        } else {
          this.setState({ transferIn: [] })
        }
      }).catch((err) => {
        this.setState({ transferIn: [], transferInLoader: false })

      })
    }

  }

  handleChange = (event, newValue) => {
    // 

    this.setState({ value: newValue })
  };
  onChange = (item) => {
    this.setState({ YearCode: item[0]?.label })

    this.props.getProfitLossDetails(0, this.props.logindetails.ClientID, this.props.date, this.props.date,
      this.props.date, 0, 0, this.props.logindetails.SessionID, 0, 3, 0, this.props.L5ID, 0, "", item[0]?.YearCode)
  }
  render() {
    //   
    const { classes } = this.props;
    // console.log(this.props.portfolioreport)
    return (
      <div className={classes.root}>
        <AppBar position="static" color="default">
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            classes={{ root: classes.tabRoot }}
            aria-label="scrollable auto tabs example"
            TabIndicatorProps={{ style: { background: window.globalConfig.color.BROWN } }}>
            <Tab label="Summary" {...a11yProps(0)} />
            <Tab label="Portfolio X-Ray" {...a11yProps(1)} />
            <Tab label="Transactions" {...a11yProps(2)} />
            <Tab label="Booked G/L" {...a11yProps(3)} />
            <Tab label="Taxation Report" {...a11yProps(4)} />
            {/* <Tab label="SIP Tracker" {...a11yProps(5)} /> */}
            <Tab label="Account Statement" {...a11yProps(5)} />
            <Tab label="Portfolio Details" {...a11yProps(6)} />
            {/* <Tab label="AFR Report" {...a11yProps(8)} /> */}
            <Tab label="X-Ray With Sold Units" {...a11yProps(7)} />
            <Tab label="Transfer In" {...a11yProps(8)} />
            <Tab label="Maturity Tracker" {...a11yProps(9)} />
            {/* <Tab label="Asset Allocation" {...a11yProps(8)} /> */}
            {/* <Tab label="Market Cap Allocation" {...a11yProps(7)} /> */}
            {/* <Tab label="Running SIP Summary" {...a11yProps(12)} /> */}
          </Tabs>
        </AppBar>
        <TabPanel value={this.state.value} index={0}>
          <Summary CategoryAllocation={labels.summaryPage.CategoryAllocation}
            Deptdata={this.props.Deptdata}
            splitByInstrument={labels.summaryPage.splitByMarketCap}
            EquityFundSector={labels.summaryPage.EquitySector}
            flag={constants.Common.Bonds}
            barChartData={this.props.barChartData}
            chart={this.props.chart}
            showChart={false}
            isLoadingportfolioSummary={this.props.isLoadingportfolioSummary}
            isLoadingportfolioChart={this.props.isLoadingportfolioChart}
            categorySummary={this.props.categorySummary}
            isLoadingcategorySummary={this.props.isLoadingcategorySummary}
            DonutData={this.props.DonutData}
            grandtotal={[labels.messages.grandtotal, labels.currency.rupeesymbol + this.props.grandtotalsummary, "", this.props.categorySummary.length == 0 ? "0%" : "100.0%"]}
            EquityLoading={this.props.isLoadingMarketCapEquity}
            DebtLoading={this.props.isLoadingMarketCapDebt}
            header={"Bond"}
            tableHeader={[Label.summaryPage.Category, Label.summaryPage.Amount, Label.summaryPage.categoryPercentage, Label.summaryPage.holdingPercentage]
            }
          />
        </TabPanel>
        <TabPanel value={this.state.value} index={1}>
          <Portifolio
            externalClasses={classes}
            flag={constants.Common.Bonds}
            grid={classes.bondSixSplitContainer}
            Total={labels.ProfitLoss.Total}
            MarketValue={labels.Tableheader.MarketValue}
            CurrentGain={labels.Tableheader.CurrentValue}
            amountLabel={labels.Tableheader.price}
            units={labels.Tableheader.Quantity}
            Subheadingunits={labels.Tableheader.Subheadingprice}
            InvestedValue={labels.Tableheader.InvestedValue}
            AsOn={labels.Tableheader.AsOn}
            totaltext={labels.Tableheader.totaltext}
            Sip={labels.Tableheader.Sip}
            xray={this.props.xray}
            header={"Bond"}
            hideGrandTotalUnitsColumn={true}
            List={this.props.List}
            filterSubmit={this.props.bondsFilterChange}
            xraysort={this.props.xraysort}
            xrayfilter={this.props.xrayfilter}
            groupXray={this.props.groupXray}
            isLoadinggroupXray={this.props.isLoadinggroupXray}
            unrealised={this.props.unrealised}
            margetvalue={this.props.margetvalue}
            investedvalue={this.props.investedvalue}
            unrealisedpercentage={this.props.unrealisedpercentage}
            catchmessage={this.props.catchmessage}
            grandtotal={this.props.grandtotal}
            grandtotalnetpl={this.props.grandtotalnetpl}
            grandtotaltotaldividend={this.props.grandtotaltotaldividend}
            grandtotalinvestmentvalue={this.props.grandtotalinvestmentvalue}
            grandtotalmarketvalue={this.props.grandtotalmarketvalue}
            grandtotalunrealised={this.props.grandtotalunrealised}
            logindetails={this.props.logindetails}
            isXrayLoading={this.props.isXrayLoading}
            Load={this.props.Load}
            TransactionLoad={this.props.TransactionLoad}
            xcelLoad={this.props.xcelLoad}
            TransactionxcelLoad={this.props.TransactionxcelLoad}
            dropdowndetails={this.props.dropdowndetails}
            title={portfolioxraytitle}
            schemeList={this.props.schemeList} />
        </TabPanel>
        <TabPanel value={this.state.value} index={2}>
          {/* TRANSACTION */}
          <Transaction grid={classes.transactionContainer}
            ReportList={this.props.financialYearsList.length == 0 ? [] : sortArray([{ label: "All", value: 0, isChecked: false }, ...this.props.financialYearsList.map((item, index) => {
              return { ...item, label: item.Year, value: index + 1, isChecked: false }
            }),], "ID", "DESC")}

            title={[{ 'name': labels.transactionSummary.date }, { 'name': labels.Tableheader.BondName }, { 'name': labels.transactionSummary.assetClass }, { 'name': labels.transactionSummary.transactionType, "subheader": labels.transactionSummary.TransactionNature }, { 'name': labels.transactionSummary.contractno }, { 'name': labels.transactionSummary.quantity }, { 'name': labels.transactionSummary.price }, { 'name': labels.transactionSummary.amount }]}
            flag={constants.Common.Bonds} isLoadingtransactionList={this.props.isLoadingtransactionList}
            L5ID={this.props.L5ID} maxDate={this.props.maxDate} minDate={this.props.minDate}
            schemeName={labels.transactionSummary.scripName}
            TransactionxcelLoad={this.props.TransactionxcelLoad} TransactionLoad={this.props.TransactionLoad}
            logindetails={this.props.logindetails} catchmessage={this.props.catchmessage}
            date={this.props.date} userID={this.props.userID} clientID={this.props.clientID}
            sessionID={this.props.sessionID}
            transactionList={this.props.transactionList != "NA" && this.props.transactionList.length != 0 ? this.props.transactionList : []}
            dropdowntransaction={this.props.dropdowntransaction}
            List={this.props.dropdowntransaction}
            filterSubmit={this.props.bonds_transactionfilter}
            header={"Transaction"}
            filterHeader={"Bond"}
          />
        </TabPanel>
        <TabPanel value={this.state.value} index={3}>
          {/* PROFIT&LOSS */}
          <Table header={"Bond"}
            grid={classes.profitLossContainer}
            flag={constants.Common.Bonds}
            ReportList={this.props.financialYearsList.length == 0 ? [] : sortArray([{ label: "All", value: 0, }, ...this.props.financialYearsList.map((item, index) => {
              return { ...item, label: item.Year, value: index + 1 }
            }),], "ID", "DESC")}
            YearCode={this.state.YearCode}
            onChange={this.onChange}
            GainValue={labels.ProfitLoss.GainValue} Units={labels.ProfitLoss.quantity} SellValueLabel={labels.ProfitLoss.SellValue}
            PurchaseValueLabel={labels.ProfitLoss.PurchaseValue} DividendValueLabel={labels.ProfitLoss.DividendValue} SchemeName={labels.Tableheader.BondName}
            Total={labels.ProfitLoss.Total}
            ProfitLoss={this.props.ProfitLoss} profitLossfilter={this.props.profitLossfilter}
            List={this.props.profitLossfilter}
            filterSubmit={this.props.bondsprofitandlossfilter}
            isLoadingProfitLoss={this.props.isLoadingProfitLoss} PurchaseValue={this.props.PurchaseValue}
            DividendValue={this.props.DividendValue} SellValue={this.props.SellValue}
            glAmount={this.props.glAmount} GainPercentage={this.props.GainPercentage}
            isProfitLossLoading={this.props.isProfitLossLoading} />
        </TabPanel>
        {/*TAXATION REPORT*/}
        <TabPanel value={this.state.value} index={4}>
          <CapitalGain flag={constants.Common.FD} externalClasses={classes} title={[{ "name": Label.capitalGain.FinancialYear }, { "name": Label.capitalGain.valuationreport }, { "name": Label.capitalGain.capitalgains }, { "name": Label.capitalGain.DividendReport }]}
            header={"Bond"}
            isCapitalgainLoading={this.props.isCapitalgainLoading} capitalGain={this.props.capitalGain} />
        </TabPanel>
        <TabPanel value={this.state.value} index={5}>
          <AccountStatement
            header={"Bond"} flag={constants.Common.Bonds}
            title={accountstatementtitle}
            grid={classes.accountStatementContainer}
            foliono={this.props.foliono}
            // accountstatement={this.props.accountstatement}
            // showwarning={this.props.showwarning}
            // totalaccountstatement={this.props.totalaccountstatement}
            withredeemed={this.props.withredeemed}
            withoutredeemed={this.props.withoutredeemed} />
        </TabPanel>
        <TabPanel value={this.state.value} index={6}>
          <PortfolioReport header={"Transaction"} externalClasses={classes} flag={constants.Common.Bonds} portfolioreport={this.props.portfolioreport}
            purprice={labels.PortfolioReport.purePrice} units={labels.PortfolioReport.quantity}
            totalreport={this.props.totalreport}
            portfoliocount={this.props.portfoliocount}
            isPortfolioReportLoading={this.props.isPortfolioReportLoading} title={portfoliotitle} />
        </TabPanel>
        <TabPanel value={this.state.value} index={7}>
          <XrayWithRedemption
            externalClasses={classes}
            schemeNameLabel={labels.xraywithredemption.scripName} invested={labels.xraywithredemption.Invested} amountLabel={labels.xraywithredemption.amount} current={labels.xraywithredemption.current} value={labels.xraywithredemption.value} Gainloss={labels.xraywithredemption.Gainloss}
            total={labels.xraywithredemption.total} units={labels.xraywithredemption.quantity} InvestedValue={labels.xraywithredemption.InvestedValue} currentvalue={labels.xraywithredemption.currentvalue}
            redemption={labels.xraywithredemption.redemption}
            GainLoss={labels.xraywithredemption.GainLoss} XrayTotal={labels.xraywithredemption.XrayTotal} Balancedunits={labels.xraywithredemption.BalancedQuantity}
            Redeemedunits={labels.xraywithredemption.RedeemedQuantity} grandtotal={labels.xraywithredemption.grandtotal}
            title={xraywithredeemptiontitle} header={"Bond"} flag={constants.Common.Bonds}
            xraywithredemption={this.props.xraywithredemption} xraywithredemptiongrouped={this.props.xraywithredemptiongrouped}
            totalxraywithredemption={this.props.totalxraywithredemption} isXrayWithRedemptionLoading={this.props.isXrayWithRedemptionLoading} />
        </TabPanel>
        <TabPanel value={this.state.value} index={8}>
          <Portifolio
            flag={constants.Common.Bonds}
            // classes={classes}
            externalClasses={{
              portfolioXrayCatrgorySevenSplitContainer: classes.bondsTransferinPortfolioXrayCategory,
              portfolioXraySevenSplitContainer: classes.bondsTransferinPortfolioXray
            }}

            hideCategory={false}
            showfilter={false}
            showdownload={false}
            showsortby={false}
            showtoggle={false}
            hideGrandTotalUnitsColumn={true}
            grid={classes.bondSixSplitContainer}
            Total={labels.ProfitLoss.Total}
            MarketValue={labels.Tableheader.MarketValue}
            // CurrentGain={labels.Tableheader.CurrentValue}
            // amountLabel={labels.Tableheader.price}
            units={labels.Tableheader.Quantity}
            Subheadingunits={labels.Tableheader.Subheadingprice}
            InvestedValue={labels.Tableheader.InvestedValue}
            AsOn={labels.Tableheader.AsOn}
            totaltext={labels.Tableheader.totaltext}
            Sip={labels.Tableheader.Sip}
            xray={this.state.transferIn}
            header={"Transaction"}
            List={this.state.transferIn}
            // filterSubmit={this.props.bondsFilterChange}
            // xraysort={this.props.bonds_transferin_xraysort}
            // xrayfilter={this.props.bonds_transferin_xrayfilter}
            // groupXray={this.props.bonds_transferin_groupXray}
            isLoadinggroupXray={this.state.transferInLoader}
            // unrealised={this.props.unrealised}
            // margetvalue={this.props.margetvalue}
            // investedvalue={this.props.investedvalue}
            // unrealisedpercentage={this.props.unrealisedpercentage}
            // catchmessage={this.props.bonds_transferin_catchmessage}
            // grandtotalnetpl={this.props.grandtotalnetpl}
            // grandtotaltotaldividend={this.props.grandtotaltotaldividend}
            // grandtotalinvestmentvalue={this.props.grandtotalinvestmentvalue}
            // grandtotalmarketvalue={this.props.grandtotalmarketvalue}
            // grandtotalunrealised={this.props.grandtotalunrealised}
            logindetails={this.props.logindetails}
            // isXrayLoading={this.props.bonds_transferin_isXrayLoading}
            // Load={this.props.Load}
            // TransactionLoad={this.props.TransactionLoad}
            // xcelLoad={this.props.xcelLoad}
            // TransactionxcelLoad={this.props.TransactionxcelLoad}
            dropdowndetails={this.props.dropdowndetails}
            title={transferIntitle}
            schemeList={this.state.transferIn} />
        </TabPanel>
        <TabPanel value={this.state.value} index={9}>
          <MaturityTracker header={"Issuer"} flag="maturitytracker" maturityTrackerBackupList={this.props.maturityTrackerBackupList} filterSubmit={this.props.filterMaturityTrackerBonds} List={this.props.maturityTrackerList} isLoading={this.props.isLoading}></MaturityTracker>
        </TabPanel>
        {/* <TabPanel value={this.state.value} index={7}>
          <MarketCapAllocation flag={constants.Common.Bonds} header={"Scrip"} title={[{ 'name': labels.marketCapAllocation.smallCap }, { 'name': labels.marketCapAllocation.midCap }, { 'name': labels.marketCapAllocation.largeCap }, { "name": labels.marketCapAllocation.others }]}
            titleAmountAge={[{ 'name': labels.Tableheader.ScripName, 'age': '' }, { 'name': labels.assetAllocation.amountAge, "age": labels.assetAllocation.Age },
            { 'name': labels.assetAllocation.amountAge, "age": labels.assetAllocation.Age }, { 'name': labels.assetAllocation.amountAge, "age": labels.assetAllocation.Age },
            { 'name': labels.assetAllocation.amountAge, "age": labels.assetAllocation.Age }, { "name": labels.assetAllocation.totalamount, 'age': "" }]}
            isMarketCapLoading={this.props.isMarketCapLoading} sessionID={this.props.sessionID} clientID={this.props.clientID}
            userID={this.props.userID} date={this.props.date} logindetails={this.props.logindetails}
            marketcapallocation={this.props.marketcapallocation} totalmarketcapallocation={this.props.totalmarketcapallocation} L5ID={this.props.L5ID} />
        </TabPanel> */}
      </div>
    );
  }
}
const mapStateToProps = state => {
  // //
  return {

    //COMMON STATE
    sessionID: state.Login.sessionID,
    clientID: state.Login.clientID,
    userID: state.Login.userID,
    date: state.Login.date,
    logindetails: state.Login.logindetails,
    L5ID: state.Login.L5ID,
    //SIPTRACKER
    siptracker: state.SipTracker.equity_siptracker,
    groupsiptracker: state.SipTracker.equity_groupsiptracker,
    totalsiptracker: state.SipTracker.equity_totalsiptracker,
    isSipTrackerLoading: state.SipTracker.equity_isSipTrackerLoading,

    //ACCOUNT STATEMENT
    foliono: replaceNull(state.Dropdown.dropdowndetails.folioNo, "NA") == "NA" ? [] : replaceNull(state.Dropdown.dropdowndetails.folioNo, "NA"),
    // accountstatement: state.Account.bonds_accountstatement != null && state.Account.bonds_accountstatement != undefined ? state.Account.bonds_accountstatement : [],
    // showwarning: state.Account.bonds_showwarning,
    // totalaccountstatement: state.Account.bonds_totalaccountstatement,
    withredeemed: replaceNull(state.Dropdown.dropdowndetails.folioNo, "NA") == "NA" ? [] : [{ "label": "All Folio", "value": "all folio" }, ...state.Dropdown.dropdowndetails.folioNo.map((item) => {
      return { "label": item.Description, "value": item.FolioNo }
    })],
    withoutredeemed: replaceNull(state.Dropdown.dropdowndetails.folioNo, "NA") == "NA" ? [] : [{ "label": "All Folio", "value": "all folio" }, ...state.Dropdown.dropdowndetails.folioNo.filter((value) => value.IsRedeemed === 0).map((item) => {
      return { "label": item.Description, "value": item.FolioNo }
    })],

    // RunningSIP

    //TAXATION REPORT
    capitalGain: state.capitalgain.bonds_capitalgain,
    isCapitalgainLoading: state.capitalgain.bonds_isCapitalgainLoading,

    //TRANSACTION
    transactionList: state.transactionList.bonds_transactionList,
    dropdowntransaction: state.transactionList.bonds_dropdowntransaction,
    isLoadingtransactionList: state.transactionList.bonds_isLoadingtransactionList,
    // sessionID: state.Login.sessionID,
    // clientID: state.Login.logindetails.ClientID,
    // userID: state.Login.userID,
    // date: state.Login.date,
    catchmessage: state.transactionList.bonds_catchmessage,
    TransactionLoad: state.transactionList.bonds_isLoadingPdf,
    TransactionxcelLoad: state.transactionList.bonds_isLoadingExcel,
    minDate: state.transactionList.bonds_minDate,
    maxDate: state.transactionList.bonds_maxDate,

    //ASSET ALLOCATION

    //PORTFOLIO REPORT
    portfolioreport: replaceNull(state.Portfolioreport.bonds_portfolioreport, "NA") != "NA" ? replaceNull(state.Portfolioreport.bonds_portfolioreport, "NA") : [],
    totalreport: state.Portfolioreport.bonds_totalreport,
    portfoliocount: state.Portfolioreport.bonds_portfoliocount,
    isPortfolioReportLoading: state.Portfolioreport.bonds_isPortfolioReportLoading,
    //SUMMARY
    barChartData: state.Summary.bonds_summary != undefined ? state.Summary.bonds_summary : [],
    chart: state.Summary.bonds_chart != undefined ? state.Summary.bonds_chart : [],
    categorySummary: state.Summary.bonds_categorySummary != undefined ? state.Summary.bonds_categorySummary : [],
    isLoadingcategorySummary: state.Summary.bonds_isLoadingcategorySummary != undefined ? state.Summary.bonds_isLoadingcategorySummary : false,
    DonutData: state.Summary.bonds_Donut != undefined ? state.Summary.bonds_Donut : [],
    grandtotalsummary: state.Summary.bonds_grandtotalIV != undefined ? state.Summary.bonds_grandtotalIV : [],
    Deptdata: state.Summary.bonds_getdeptdata,
    isLoadingportfolioChart: state.Sample.isLoadingportfolioChart,
    isLoadingportfolioSummary: state.Sample.isLoadingportfolioSummary,
    isLoadingMarketCapEquity: state.Summary.isLoadingMarketCapEquity,
    isLoadingMarketCapDebt: state.Summary.isLoadingMarketCapDebt,

    // PROFITANDLOSS
    ProfitLoss: state.ProfitLoss.bonds_profitLoss,
    profitLossfilter: state.ProfitLoss.bonds_profitLossfilter,
    isLoadingProfitLoss: state.ProfitLoss.bonds_isLoadingProfitLoss,
    PurchaseValue: state.ProfitLoss.bonds_grandpurchasetotal,
    DividendValue: state.ProfitLoss.bonds_granddivdend,
    SellValue: state.ProfitLoss.bonds_grandselltotal,
    glAmount: state.ProfitLoss.bonds_grandglamount,
    GainPercentage: state.ProfitLoss.bonds_GainPercentage,
    isProfitLossLoading: state.ProfitLoss.bonds_isProfitLossLoading,

    //AFR REPORT


    //X-RAY WITH REDEEM
    xraywithredemption: state.Redemption.bonds_xraywithredemption,
    xraywithredemptiongrouped: state.Redemption.bonds_xraywithredemptiongrouped,
    totalxraywithredemption: state.Redemption.bonds_totalxraywithredemption,
    isXrayWithRedemptionLoading: state.Redemption.bonds_isXrayWithRedemptionLoading,


    //PORTFOLIO-X-RAY
    xray: state.PortfolioXray.bonds_xray,

    isLoadinggroupXray: state.PortfolioXray.bonds_isXrayLoading,

    unrealised: state.Card.mfHeader2.filter((val) => val.firstName === "Unrealised G / L (%)").map((val) => {
      return val.lastName
    }),
    margetvalue: state.Card.mfHeader2.filter((val) => val.firstName === "MF Market Value").map((val) => {
      return val.lastName
    }),
    investedvalue: state.Card.mfHeader2.filter((val) => val.firstName === "Investment Value").map((val) => {
      return val.lastName
    }),
    unrealisedpercentage: state.Card.mfHeader2.filter((val) => val.firstName === "Unrealised G / L (%)").map((item) => {
      return item.val
    }),
    List: state.PortfolioXray.bonds_XrayData.length == 0 ? [] : state.PortfolioXray.bonds_XrayData.filter(
      (ele, ind) =>
        ind ===
        state.PortfolioXray.bonds_XrayData.findIndex((elem) => elem.Scheme === ele.Scheme)
    ),
    logindetails: state.Login.logindetails,

    dropdowndetails: state.Dropdown.dropdowndetails.scheme,
    financialYearsList: replaceNull(state.Dropdown.dropdowndetails.financialYearsList, "").length != 0 ? state.Dropdown.dropdowndetails.financialYearsList : [],

    // xray: state.PortfolioXray.xraysort,
    schemeList: state.PortfolioXray.bonds_XrayData.sort(function (a, b) {
      var textA = a.Scheme.toUpperCase();
      var textB = b.Scheme.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    }),
    //Transfer In

    maturityTrackerList: state.MaturityTracker.maturityTrackerBonds == "NA" ? [] : state.MaturityTracker.maturityTrackerBonds,
    isLoading: state.MaturityTracker.isMaturityTrackerBondsLoading,
    maturityTrackerBackupList: state.MaturityTracker.maturityTrackerBondsBackup


  }
}
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {

      bondsFilterChange,
      bonds_transactionfilter,
      bondsprofitandlossfilter,
      filterMaturityTrackerBonds,
      getProfitLossDetails
    },
    dispatch
  );
};
const mergestyles = combineStyle(Styles, commonstyletable);
export default withStyles(mergestyles)(connect(mapStateToProps, mapDispatchToProps)(BondsTab))